export default __webpack_public_path__ + "static/media/26EF7221-5055-4CCB-BF98-1F4C5C410A37.0234fe89.jpeg";